var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94225 8.72042V15H2.2427V8.72042H0V6.17419H2.2427V5.24778C2.2427 1.80843 3.58728 0 6.43219 0C7.30435 0 7.52239 0.149778 8 0.27182V2.79031C7.46528 2.69046 7.31473 2.63499 6.75925 2.63499C6.09993 2.63499 5.74692 2.83469 5.42505 3.22855C5.10318 3.62241 4.94225 4.30473 4.94225 5.28106V6.17973H8L7.17975 8.72596H4.94225V8.72042Z",
    fill: "#EE2D2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.b676faa8.svg";
export { ForwardRef as ReactComponent };